import React from 'react';
import { DollarSignIcon, TrendingDownIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
export function CostComparisonSection() {
  return <section className="py-20 bg-gradient-to-b from-white to-slate-50" data-id="element-199">
      <div className="container mx-auto px-4" data-id="element-200">
        <div className="max-w-6xl mx-auto" data-id="element-201">
          <div className="text-center mb-16" data-id="element-202">
            <div className="inline-block bg-emerald-50 rounded-full px-4 py-2 mb-4" data-id="element-203">
              <span className="text-emerald-700 font-semibold text-sm tracking-wide uppercase" data-id="element-204">
                Cost Comparison
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-205">
              IVF in Europe:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-emerald-700" data-id="element-206">
                60–80% Cheaper
              </span>
            </h2>
            <p className="text-slate-600 text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-207">
              Comparing typical per-cycle costs in the U.S., UK, and Canada
              versus our partner EU clinics. Same world-class care,
              significantly lower prices.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-208">
            {/* Typical IVF at Home */}
            <div className="bg-white border-2 border-slate-200 rounded-3xl p-8 relative" data-id="element-209">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-slate-700 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-210">
                At Home
              </div>
              <div className="text-center mb-6 pt-4" data-id="element-211">
                <div className="bg-slate-100 p-4 rounded-2xl inline-block mb-4" data-id="element-212">
                  <DollarSignIcon className="text-slate-600" size={32} data-id="element-213" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-214">
                  US / UK / Canada
                </h3>
                <div className="text-3xl font-black text-slate-900 mb-2" data-id="element-215">
                  $15,000 - $30,000
                </div>
                <p className="text-sm text-slate-600" data-id="element-216">Per IVF cycle</p>
              </div>
              <div className="space-y-3 mb-6" data-id="element-217">
                <div className="flex items-start gap-2" data-id="element-218">
                  <AlertCircleIcon className="text-slate-400 flex-shrink-0 mt-0.5" size={18} data-id="element-219" />
                  <span className="text-slate-600 text-sm" data-id="element-220">
                    Clinic treatment costs only
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-221">
                  <AlertCircleIcon className="text-slate-400 flex-shrink-0 mt-0.5" size={18} data-id="element-222" />
                  <span className="text-slate-600 text-sm" data-id="element-223">
                    Additional fees often apply
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-224">
                  <AlertCircleIcon className="text-slate-400 flex-shrink-0 mt-0.5" size={18} data-id="element-225" />
                  <span className="text-slate-600 text-sm" data-id="element-226">
                    Medications extra ($3,000-$5,000)
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-227">
                  <AlertCircleIcon className="text-slate-400 flex-shrink-0 mt-0.5" size={18} data-id="element-228" />
                  <span className="text-slate-600 text-sm" data-id="element-229">
                    Limited insurance coverage
                  </span>
                </div>
              </div>
            </div>
            {/* IVF in EU Clinics */}
            <div className="bg-gradient-to-br from-emerald-50 to-green-50 border-2 border-emerald-300 rounded-3xl p-8 relative shadow-lg" data-id="element-230">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-emerald-600 to-emerald-700 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-231">
                Our EU Clinics
              </div>
              <div className="text-center mb-6 pt-4" data-id="element-232">
                <div className="bg-gradient-to-br from-emerald-500 to-emerald-600 p-4 rounded-2xl inline-block mb-4" data-id="element-233">
                  <DollarSignIcon className="text-white" size={32} data-id="element-234" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-235">
                  Europe
                </h3>
                <div className="text-3xl font-black text-emerald-700 mb-2" data-id="element-236">
                  €3,200 - €7,200
                </div>
                <p className="text-sm text-slate-600" data-id="element-237">
                  Complete coordination package
                </p>
              </div>
              <div className="space-y-3 mb-6" data-id="element-238">
                <div className="flex items-start gap-2" data-id="element-239">
                  <CheckCircleIcon className="text-emerald-600 flex-shrink-0 mt-0.5" size={18} data-id="element-240" />
                  <span className="text-slate-700 text-sm font-medium" data-id="element-241">
                    Clinic treatment included
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-242">
                  <CheckCircleIcon className="text-emerald-600 flex-shrink-0 mt-0.5" size={18} data-id="element-243" />
                  <span className="text-slate-700 text-sm font-medium" data-id="element-244">
                    Fixed, transparent pricing
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-245">
                  <CheckCircleIcon className="text-emerald-600 flex-shrink-0 mt-0.5" size={18} data-id="element-246" />
                  <span className="text-slate-700 text-sm font-medium" data-id="element-247">
                    Full coordination & translator
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-248">
                  <CheckCircleIcon className="text-emerald-600 flex-shrink-0 mt-0.5" size={18} data-id="element-249" />
                  <span className="text-slate-700 text-sm font-medium" data-id="element-250">
                    Travel guidance included
                  </span>
                </div>
              </div>
            </div>
            {/* Your Total Savings */}
            <div className="bg-white border-2 border-blue-200 rounded-3xl p-8 relative" data-id="element-251">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-252">
                Your Savings
              </div>
              <div className="text-center mb-6 pt-4" data-id="element-253">
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-4 rounded-2xl inline-block mb-4" data-id="element-254">
                  <TrendingDownIcon className="text-white" size={32} data-id="element-255" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-256">
                  Total Savings
                </h3>
                <div className="text-3xl font-black text-blue-600 mb-2" data-id="element-257">
                  60-80%
                </div>
                <p className="text-sm text-slate-600" data-id="element-258">
                  For comparable treatment
                </p>
              </div>
              <div className="space-y-3 mb-6" data-id="element-259">
                <div className="flex items-start gap-2" data-id="element-260">
                  <CheckCircleIcon className="text-blue-600 flex-shrink-0 mt-0.5" size={18} data-id="element-261" />
                  <span className="text-slate-600 text-sm" data-id="element-262">
                    Even with travel costs included
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-263">
                  <CheckCircleIcon className="text-blue-600 flex-shrink-0 mt-0.5" size={18} data-id="element-264" />
                  <span className="text-slate-600 text-sm" data-id="element-265">
                    Same world-class care standards
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-266">
                  <CheckCircleIcon className="text-blue-600 flex-shrink-0 mt-0.5" size={18} data-id="element-267" />
                  <span className="text-slate-600 text-sm" data-id="element-268">
                    Flexible payment plans available
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-269">
                  <CheckCircleIcon className="text-blue-600 flex-shrink-0 mt-0.5" size={18} data-id="element-270" />
                  <span className="text-slate-600 text-sm" data-id="element-271">
                    No hidden fees or surprises
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Footnote */}
          <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6 text-center" data-id="element-272">
            <p className="text-slate-600 text-sm leading-relaxed" data-id="element-273">
              <strong className="text-slate-900" data-id="element-274">Note:</strong> Prices are
              approximate and vary by individual case, specific treatment plan,
              and clinic. Cost comparison based on typical IVF cycle costs in
              the US, UK, and Canada versus our partner EU clinics. Your
              coordinator will provide exact pricing during consultation.
            </p>
          </div>
        </div>
      </div>
    </section>;
}